import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Injectable({
  providedIn: 'root'
})
export class FteService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetGroup', data);
  }

  getPlantsData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetDepartments', data);
  }

  getMasterFrequencies(data: any): Observable<any[]> {
    // return this.http.get<any[]>(this.kpiBaseUrl +'taskfrequency' )
    return this.http.get<any[]>(this.O3CoreApiUrl + 'Task/GetFrequency');
  }

  getMasterProject(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'project/GetMasterProjects', data);
  }

  getMasterTopic(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.kpiBaseUrl + 'getAllTopicByProject', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Fte/GetAllTopicByProject', data);
   
  }

  GetTaskByTopicId(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.kpiBaseUrl + 'getAllTaskByTopic', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Fte/GetAllTaskByTopic', data);
    
  }

  AddFTE(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.kpiBaseUrl + 'addFTE', data);
      return this.http.post<any[]>(this.O3CoreApiUrl + 'Fte/AddFTE', data);

    
  }

  GetAllFTE(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Fte/GetAllFTE', data);
  }

  GetFTEById(data: any): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Fte/GetFTEById', data);
  }

  DeleteFTE(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.kpiBaseUrl + 'deleteFTE', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Fte/DeleteFTE', data);
    
  }

  UpdateFTE(data: any): Observable<any[]> {
    // return this.http.put<any[]>(this.kpiBaseUrl + 'updateFTE', data);
    return this.http.put<any[]>(this.O3CoreApiUrl + 'Fte/UpdateFTE', data);
  }
}
